import { render, staticRenderFns } from "./global-alert.vue?vue&type=template&id=42cf0d33&scoped=true&"
import script from "./global-alert.vue?vue&type=script&lang=js&"
export * from "./global-alert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cf0d33",
  null
  
)

export default component.exports